<div class="mysteryschool_header_navwrap">
  <div class="left_sectionwrap">
    <div class="left_logotitlewrap">
      <div class="left_logo">
        <img
          src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
          alt=""
        />
      </div>
      <div class="left_title">
        <h1 data-text="SCHOOL OF OUR">SCHOOL OF OUR</h1>
        <h2 data-text="DIVINE INFINITE BEING">DIVINE INFINITE BEING</h2>
      </div>
    </div>
    <h2 class="left_heading">MYSTERY SCHOOL</h2>
  </div>
  <div class="section_for_responsive">
    <p class="responsive_title">SCHOOL OF OUR DIVINE INFINITE BEING</p>
    <h2 class="left_heading">MYSTERY SCHOOL</h2>
  </div>
  <div class="rightsection_menuwrap" [class.showmenu]="classToggled">
    <ul>
      <li
        routerLinkActive="active"
        [ngClass]="currentPath() == '/mystery-school-dashboard' ? 'active' : ''"
      >
        <a (click)="navigateToPath('/mystery-school-dashboard')">The Wheel</a>
      </li>

      <li
        routerLinkActive="active"
        [ngClass]="
          currentPath() == '/mystery-school-dashboard/training-center'
            ? 'active'
            : ''
        "
      >
        <a (click)="navigateToPath('/mystery-school-dashboard/training-center')"
          >Training</a
        >
      </li>
    </ul>
  </div>
  <div (click)="toggleNav()" class="toggleBtn">
    <i class="fa fa-bars" aria-hidden="true"></i>
  </div>
</div>
